import { useState, useEffect, useRef, useCallback } from 'react';
import getUserHasSeen from '../services/getUserHasSeen';

interface UseUserHasSeenOptions {
  duration?: Duration;
  shouldPreventAutoSeen?: boolean;
}

const useUserHasSeen = (
  nameOfWhatToSee: string,
  userId: string | number | null,
  options: UseUserHasSeenOptions = {}
) => {
  const initialOptions = useRef(options);
  const [hasSeen, setHasSeen] = useState<boolean | undefined>(undefined);

  const localStorageKey = `has-seen-${nameOfWhatToSee}`;

  const userHasSeenService = userId ? getUserHasSeen(userId) : undefined;

  const persistHasSeen = useCallback(() => {
    setHasSeen(true);
    return userHasSeenService?.set(
      nameOfWhatToSee,
      initialOptions.current.duration ? { duration: initialOptions.current.duration } : undefined
    );
  }, [nameOfWhatToSee, userHasSeenService]);

  useEffect(() => {
    if (!userHasSeenService) {
      return;
    }

    userHasSeenService.get(nameOfWhatToSee).then((hasSeenStoredValue) => {
      setHasSeen(Boolean(hasSeenStoredValue));
      if (!initialOptions.current.shouldPreventAutoSeen) {
        persistHasSeen();
      }
    });
  }, [userHasSeenService, localStorageKey, nameOfWhatToSee, persistHasSeen]);

  return { hasSeen, setSeen: persistHasSeen };
};

export default useUserHasSeen;
